import * as React from "react";

import {
  ArrowDownUpIcon,
  Settings2Icon,
} from "lucide-react";

import { Button } from "@/shared-web.ui/ui.button";
import { Text, type TextProps } from "@/shared-web.ui/ui.text";
import { cn } from "@/shared-web.ui/util.cn";

interface FilterTriggerProps extends React.ComponentPropsWithoutRef<typeof Button> {}
const FilterTrigger = React.forwardRef<
  React.ElementRef<typeof Button>,
  FilterTriggerProps
>((props, ref) => {
  const { children, ...buttonProps } = props;

  return (
    <Button ref={ref} variant="ghost" {...buttonProps}>
      <Settings2Icon className="size-4" />
      {children}
    </Button>
  );
});
FilterTrigger.displayName = "Tune.FilterTrigger";

type FilterTriggerTextProps = TextProps;
const FilterTriggerText = React.forwardRef<
  React.ElementRef<typeof Text>,
  FilterTriggerTextProps
>((props, ref) => {
  const { children, className, ...textProps } = props;

  return (
    <Text
      ref={ref}
      className={cn(
        `text-3`,
        className,
      )}
      as="span"
      {...textProps}
    >
      {children}
    </Text>
  );
});
FilterTriggerText.displayName = "Tune.FilterTriggerText";

interface SortTriggerProps extends React.ComponentPropsWithoutRef<typeof Button> {}
const SortTrigger = React.forwardRef<
  React.ElementRef<typeof Button>,
  SortTriggerProps
>((props, ref) => {
  const { children, ...buttonProps } = props;

  return (
    <Button ref={ref} variant="ghost" {...buttonProps}>
      <ArrowDownUpIcon className="size-4" />
      {children}
    </Button>
  );
});
SortTrigger.displayName = "Tune.SortTrigger";

export {
  FilterTrigger,
  FilterTriggerText,
  SortTrigger,
};
